import request from '@/api/request'

// 下载模板
export function importTemplate() {
  return request({
    url: `/consumables/eng/importTemplate`,
    method: 'post',
    responseType: 'blob'
  })
}

// 获取工程耗材列表
export function consumableList(params) {
  return request({
    url: `/consumables/eng/list`,
    method: 'get',
    params
  })
}

// 新增工程耗材
export function addEngConsumables(data) {
  return request({
    url: `/consumables/eng/list`,
    method: 'post',
    data
  })
}

// 修改工程耗材
export function updateEngConsumables(data) {
  return request({
    url: `/consumables/eng/list`,
    method: 'put',
    data
  })
}

// 删除工程耗材
export function delEngConsumables(id) {
  return request({
    url: `/consumables/eng/list/${id}`,
    method: 'delete'
  })
}

// 查询工程耗材
export function getEngConsumables(id) {
  return request({
    url: `/consumables/eng/list/${id}`,
    method: 'get'
  })
}

// 查询工程耗材分类
export function getEngConsumablesItems() {
  return request({
    url: `/consumables/eng/classList`,
    method: 'get'
  })
}